<div class="row">
  <div class="col-12 text-primary font-weight-bold mb-2">
    {{'DATA_STUDIO.DATA_PARAMETERS.AVAILABLE_SIGNALS' |translate}}
  </div>
  <div class="col-12 d-flex justify-content-between border rounded w-100 p-2 mb-3 text-primary">
    <mat-checkbox [checked]="selectAllSignalsFlag" (change)="selectAllSignals()">
      <b>{{'DATA_STUDIO.SIGNALS.ALL_SIGNALS' |translate}}</b></mat-checkbox>
      <span><small>{{totalSignalsSelected}} {{'COMMON.OF' |translate}} {{totalSignals}}</small></span>
    </div>
    @for (signalGroup of signalGroupArray; track $index; let isLast = $last) {
      <div
        class="col-12 d-flex flex-column border rounded w-100 p-2 mb-3 text-primary" [class.mb-3]="!isLast">
        <div class="d-flex justify-content-between">
          <mat-checkbox [(ngModel)]="signalGroup.signalGroupName.checked"
            (change)="selectAllSignalsByGroup(signalGroup.signalGroupName.name)">
            <b>{{('DATA_STUDIO.SIGNALS.GROUPS.' + signalGroup.signalGroupName.name.toUpperCase()) |translate
            }}</b></mat-checkbox>
            <small>{{signalGroupSelected[signalGroup.signalGroupName.name]}}
              {{'COMMON.OF' |translate}} {{signalGroup.signals.length}}
            </small>
          </div>
          <div>
            <hr class="my-1">
          </div>
          <div class="row">
            @for (signals of signalGroup.signals; track $index; let i = $index) {
              <div class="col-4 pr-2">
                <mat-checkbox [(ngModel)]="signals.checked" [value]="signals.value" (change)="checkSelectedSignals()">
                  <span [appCustomTooltip]="tooltipTemplate">{{signals.name | translate }}
                    @if (!checkSignalTurbineType(signals.value)) {
                      <i class="far fa-info-circle color-orange pointer pl-1"></i>
                    }
                  </span>
                </mat-checkbox>
                <ng-template #tooltipTemplate>
                  <div>
                    <b>{{signals.name | translate }}</b><br>
                    {{signals.value}}
                    <hr class="my-1">
                    {{signals.description | translate }}<br>
                    @if (!checkSignalTurbineType(signals.value)) {
                      <div class="color-orange">
                        <hr class="my-1">
                        <i class="far fa-info-circle pointer pl-1"></i>
                        {{'DATA_STUDIO.DATA_PARAMETERS.ONLY_AVAILABLE' |translate}} {{typesDiff(signals.value)}}
                        {{'DATA_STUDIO.DATA_PARAMETERS.TURBINE_TYPE' |translate |lowercase}}(s)
                      </div>
                    }
                  </div>
                </ng-template>
              </div>
            }
          </div>
        </div>
      }
    </div>